<template>

  <div style="width: 100%;height:100%">
    <div class="edit-location">
      <div class="edit-location-form form">
<!--         <div class="close-modal">
          <button type="button" class="close" aria-label="Close" v-on:click="closeEdit">
            <span aria-hidden="true" style="font-size:2em" class="align-middle">&times;</span>
            <span class="align-middle">close</span>
          </button>
        </div> -->
        <div class="edit-location-content">
        <div v-if="batchEdition"> <strong><h4>Editing {{selectedEntities.length}} items</h4></strong></div>

            <div class="row">
                <div class="col-md-12" >
                   <div v-if="batchEdition" class="pull-left mb-4">
                      <select class="form-control" style="min-width: 200px;">
                        <option v-for="item in selectedEntities">{{item.id}} - {{item.address.streetAddress}}, {{item.address.addressLocality}}, {{item.address.addressRegion}} {{item.address.postalCode}}</option>
                      </select>
                   </div>

                  <div class="pull-right mb-4">
                    <button class="btn btn-danger" v-on:click="closeEdit">Cancel</button>
                    <button class="btn btn-primary btn-md ml-4 b-4" v-on:click="saveDataOffer" :disabled="batchEdition && !batchButtonEnabled">
                      <span v-if="batchEdition">Update {{selectedEntities.length}} items</span>
                      <span v-if="newEntity">Save New Offer</span>
                      <span v-if="!newEntity && !batchEdition">Save Offer Updates</span>
                   </button>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header">
                  <strong>Offer Details</strong>
                </div>
                <div class="card-body edit-location-address-info">
                  <div class="row">

                        <div class="col-md-6">
                          <div class="form-group">
                          <label for="businessFunction" >Offer type</label>
                           <vue-select
                            :class="{'input form-control': true, 'is-invalid form-control': errors.has('businessFunction') }"
                            inputId="businessFunction"
                            v-if="isOfferFieldVisible('businessFunction')"
                            :searchable="false"
                            :filterable="false"
                            style="padding: 0px"
                            v-validate="validationRuleForOfferField('businessFunction')"
                            data-vv-name="businessFunction"
                            v-model="editOffer.businessFunction"
                            :getOptionLabel="businessFunctionLabelOption"
                            :options='["Banner - XS","Banner - SM MD LG","Site Grid","Location Grid"]'
                          />
                          <span v-show="errors.has('businessFunction')" class="help is-invalid">{{ errors.first('businessFunction') }}</span>
                        </div>
                        </div>


                      <div class="col-md-6">
                        <text-input
                          :validationRule="validationRuleForOfferField('alternateName')"
                         v-if="isOfferFieldVisible('alternateName')"
                         inputId="alternateName"
                         v-model="editOffer.alternateName"
                         label="Offer code"  />
                      </div>


                      <div class="col-md-6">
                        <text-input
                          :validationRule="validationRuleForOfferField('name')"
                         v-if="isOfferFieldVisible('name')"
                         inputId="name"
                         v-model="editOffer.name"
                         label="Name"  />
                      </div>


                      <div class="col-md-6">
                        <text-input
                          :validationRule="validationRuleForOfferField('url')"
                         v-if="isOfferFieldVisible('url')"
                         inputId="url"
                         v-model="editOffer.url"
                         label="Url"  />
                      </div>


                        <div class="col-md-6">
                           <place-input
                              v-if="isOfferFieldVisible('eligibleRegion')"
                              inputId="eligibleRegion"
                              v-model="editOffer.eligibleRegion"
                              label="Included Places"
                              emptyLabel="Available everywhere"
                               />
                        </div>


                        <div class="col-md-6">
                           <place-input
                              v-if="isOfferFieldVisible('ineligibleRegion')"
                              inputId="ineligibleRegion"
                              v-model="editOffer.ineligibleRegion"
                              label="Excluded Places"
                              emptyLabel="No restrictions"
                               />
                        </div>




                      <div class="col-md-6">
                        <text-input
                         v-if="isOfferFieldVisible('itemCondition.name')"
                         inputId="itemCondition.name"
                         v-model="editOffer.itemCondition.name"
                         label="Secondary action"  />
                      </div>


                      <div class="col-md-6">
                        <text-input
                         v-if="isOfferFieldVisible('itemCondition.url')"
                         inputId="itemCondition.url"
                         v-model="editOffer.itemCondition.url"
                         label="Secondary landing page"  />
                      </div>


                      <div class="col-md-6">
                        <text-input
                         v-if="isOfferFieldVisible('itemOffered.name')"
                         inputId="itemOffered.name"
                         v-model="editOffer.itemOffered.name"
                         label="Call to action"  />
                      </div>


                      <div class="col-md-6">
                        <text-input
                         v-if="isOfferFieldVisible('description')"
                         inputId="description"
                         v-model="editOffer.description"
                         label="Description"  />
                      </div>


                      <div class="col-md-6">
                        <text-input
                         v-if="isOfferFieldVisible('price')"
                         inputId="price"
                         v-model="editOffer.price"
                         label="Price"  />
                      </div>


                      <div class="col-md-6">
                        <text-input
                         v-if="isOfferFieldVisible('warranty')"
                         inputId="warranty"
                         v-model="editOffer.warranty"
                         label="Warranty"  />
                      </div>


                      <div class="col-md-6">
                        <date-input
                        v-if="isOfferFieldVisible('availabilityEnds')"
                        inputId="availabilityEnds"
                        v-model="editOffer.availabilityEnds"
                        label="Expires"  />
                      </div>


                  </div>
                </div>
              </div>
              <!-- Properties Blocks -->
                <div class="card" >
                  <div class="card-header">
                    <strong>Images</strong>
                  </div>
                  <div class="card-body" style="padding: 20px">
                    <div class="row">

                  <div class="col-md-6">
                    <remote-image
                    v-if="isOfferFieldVisible('image')"
                    inputId="image"
                        :validationRule="validationRuleForOfferField('image')"
                    v-model="editOffer.image" label="Image"></remote-image>
                  </div>
                    </div>
                   </div>
                </div>
                <div class="card">
                  <div class="card-header">
                    <strong>Eligible Duration</strong>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-12">
                           <runtime-hours
                           v-if="isOfferFieldVisible('eligibleDuration')"
                           inputId="eligibleDuration"
                            label="Eligible Duration"
                            data-vv-name="eligibleDuration"
                            v-model="editOffer.eligibleDuration"
                            :showValidFrom="true"
                            :showValidThrough="true"
                            :showDayOfWeek="true"
                            :showAllDaysOfWeek="true"
                            :showToggleDay="batchEdition"
                            v-on:daytoggle="toggleBatchDay"
                            :optionalFields='["showValidThrough","showDayOfWeek"]'
                            :showClosed="false"
                            :allDayChecked="true"
                            dayOfWeekLabel="Day of Week enabled"
                            dateFromLabel="Valid on"
                            dateThroughLabel="Expires"
                            allDayLabel="Show all day"
                            opensLabel="Show at"
                            closesLabel="Hide at"
                            :showPopulateMatchesButton="batchEdition"
                            ></runtime-hours>
                      </div>
                    </div>
                  </div>
                </div>


      </div>
    </div>
  </div>
  <modal title="Modal title" class="modal-danger" v-model="confirmModal" @ok="saveBatchEditFields" effect="fade/zoom">
    <div slot="modal-header" class="modal-header">
      <h4 class="modal-title">Are you sure you want to update these {{this.selectedEntities.length}} Locations?</h4>
    </div>
    The following fields will be updated:
    <ul>
    <li v-bind:key="item" v-for="item in batchEditFieldsApplied">
       {{item}}
    </li>
    </ul>
    This cannot be undone.
  </modal>
 </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import { db } from '../../firebase'
import { dropdown } from "vue-strap";
import modal from "vue-strap/src/Modal";
// dynamic imports
import AdditionalProp from './widgets/additional-props.vue'
import PostalAddress from './widgets/postal-address.vue'
import TextInput from './widgets/text-input.vue'
import RemoteImage from './widgets/remote-image.vue'
import StoreHours from './widgets/runtime-hours.vue'
import RunTimeHours from './widgets/runtime-hours.vue'
import FaxOrPhoneNumberInput from './widgets/fax-number-input.vue'
import DateInput from './widgets/date-input.vue'
import BusinessFunctionCombo from 'vue-select'
import DurationTime from './widgets/runtime-hours.vue'
import PlaceComponent from './widgets/place-input.vue'


Vue.use(VeeValidate, { fastExit: false })

export default {
  props: {
    selectedEntities: { type: Array, default: function () { return [] } }
  },
  data: function () {
    return {
      editOffer: {"@context":"http://schema.org/","@type":"Offer","alternateName":"","availabilityEnds":"2018-01-01","businessFunction":"","description":"","eligibleDuration":[],"eligibleRegion":"","image":"","ineligibleRegion":"","itemCondition":{"@type":"OfferItemCondition","name":"","url":""},"itemOffered":{"@type":"Product","name":""},"name":"","price":"","url":"","warranty":""},
    batchEditionFields:[],
      newEntity: true,
      batchEdition: false,
      hasBranchCode: false,
      childValidations:[],
      batchEditFields:{},
      batchEditDays:[],
      shouldClearAllHolidays: false,
      confirmModal: false,
      batchEditFieldsApplied: []
    }
  },
  components: {
    'additional-props': AdditionalProp,
    'postal-address': PostalAddress,
    'text-input': TextInput,
    'remote-image': RemoteImage,
    'runtime-hours': StoreHours,
    'runtime-hours': RunTimeHours,
    'fax-number-input': FaxOrPhoneNumberInput,
    'date-input': DateInput,
    'vue-select': BusinessFunctionCombo,
    'runtime-hours': DurationTime,
    'place-input': PlaceComponent
    ,
    'dropdown' : dropdown,
    'modal' : modal
  },
  // mixins: [datemixin, geomixin],
  created: function () {
    const self = this
    //register for child validation interceptors
    this.$on('child-validation', function(validationFunc) {
      if (this.childValidations.indexOf(validationFunc) == -1) {
         this.childValidations.push(validationFunc)
      }
    })

    this.batchEdition = this.selectedEntities.length > 0
    if (this.batchEdition) {
      this.newEntity = false
      this.$on('populate-matches', this.loadMatchedHours)
      this.$on('clear-all-holidays', this.clearAllHolidays)
    }

    if (isEmpty(this.editOffer.alternateName)) {
      this.editOffer.alternateName = rndID()
      //if repeated generate a new one
      db.ref('/Offer/' + this.$route.params.organization)
        .orderByChild('alternateName')
        .equalTo(this.editOffer.alternateName)
        .once('value', snapshot => {
          if (snapshot.val()) {
            console.log("REPEATED ID > " + snapshot.val());
            this.editOffer.alternateName = rndID()
          }
        })
    }
 
    // Fetch LocalBusiness because  Place's component search
    this.$store.dispatch('fetchDatabase', { firebaseNode: 'LocalBusinesses',  onFetchResult: (results) => {} })

    // To be sure the main list will be loaded case come diretly to edition using deep link or full refresh
    this.$store.dispatch('fetchDatabase', { firebaseNode: 'Offer',  onFetchResult: (results) => {} })


     const dictionary = {
      en: {
        messages: {
          streetAddress: () => 'Street Address is required'
        },
        attributes: {
          'streetAddress': 'street address',
          'storeID': 'store id',
          'postalCode': 'ZIP code',
          'phone': 'phone',
          'businessFunction': 'Offer type',
          'alternateName': 'Offer code',
          'name': 'Name',
          'url': 'Url',
          'eligibleRegion': 'Included Places',
          'ineligibleRegion': 'Excluded Places',
          'image': 'Image',
          'eligibleDuration': 'Eligible Duration',
          'itemCondition.name': 'Secondary action',
          'itemCondition.url': 'Secondary landing page',
          'itemOffered.name': 'Call to action',
          'description': 'Description',
          'price': 'Price',
          'warranty': 'Warranty',
          'availabilityEnds': 'Expires'
        }
      }
    }
    this.$validator.updateDictionary(dictionary)
  },
  updated: function () {
  },
  methods: {
    loadMatchedHours(inputId) {
      let compList = this.editOffer[inputId]
      let matchesMap = {}
      let matchesList = []
      let countTotal = 0
      if (compList) {
        _.each(this.selectedEntities, entity => {
           let hours = entity[inputId]
           _.each(hours, h => {
              let _id = JSON.stringify(h)
              countTotal++
              if (matchesMap[_id] == null) {
                 matchesMap[_id] = h
                 matchesList.push(h)
              }
           })
         })

        matchesList.sort(function(a, b) {
          let validFromA = a["validFrom"]
          let opensA = a["opens"]
          let closesA = a["closes"]
          let dayOfWeekA = a["dayOfWeek"]
          let validFromB = b["validFrom"]
          let opensB = b["opens"]
          let closesB = b["closes"]
          let dayOfWeekB = b["dayOfWeek"]
          let sortStringA = ""
          let sortStringB = ""

          if (dayOfWeekA != null && dayOfWeekA.length > 0){
            dayOfWeekA = dayOfWeekA.replace("http://schema.org/", "")
            dayOfWeekB = dayOfWeekB.replace("http://schema.org/", "")

            let weekDays = {"Sunday": "1", "Monday": "2", "Tuesday": "3", "Wednesday": "4", "Thursday": "5", "Friday": "6", "Saturday": "7" }

            sortStringA = weekDays[dayOfWeekA] + "-" + opensA + "-" + closesA
            sortStringB = weekDays[dayOfWeekB] + "-" + opensB  + "-" + closesB
          } else if (validFromA) {
            sortStringA = validFromA + "-" + opensA + "-" + closesA
            sortStringB = validFromB + "-" + opensB + "-" + closesB
          } else {
            sortStringA = ""
            sortStringB = ""
          }
          if (sortStringA > sortStringB ) {
            return 1
          } else if (sortStringA < sortStringB ) {
            return -1
          }
          return 0

        })

        this.editOffer[inputId] = matchesList
        console.log('loadMatchedHours: Common:' + Object.keys(matchesList).length +' Original: ' + countTotal)
        console.log(matchesList)
      }
    },
    clearAllHolidays: function (event) {
      this.shouldClearAllHolidays = event
    },
    businessFunctionLabelOption(val) {
      let options = ["Banner - XS","Banner - SM MD LG","Site Grid","Location Grid"]
      let optionsLabels = {"Banner - XS":"Mobile Banner","Banner - SM MD LG":"Desktop Banner","Site Grid":"National Offer","Location Grid":"Local Offer"}
      if (optionsLabels) {
        return optionsLabels[val]
      } else {
        return val
      }
    },
    validationRuleForOfferField(key) {
      const businessFunction = this.editOffer.businessFunction
      const bannerOptions = ["Banner - XS", "Banner - SM MD LG"]
      if (key === 'image' && !bannerOptions.includes(businessFunction)) {
        return ''
      }

      if (key === 'name' && !bannerOptions.includes(businessFunction)) {
        return ''
      }


      return 'required'

    },
    isOfferFieldVisible : function (fieldKey){
      const businessFunction = this.editOffer.businessFunction

      if (fieldKey == "businessFunction") {
        return true
      } else if ( !businessFunction || businessFunction.length == 0) {
        return false
      }

      const bannerFields = ["name", "url", "image", "validFrom", "validThrough", "eligibleRegion", "ineligibleRegion", "eligibleDuration", "alternateName", "businessFunction"]

      const gridFields = ["name", "url", "image", "validFrom", "validThrough", "price", "description", "availabilityEnds", "eligibleRegion", "ineligibleRegion", "eligibleDuration", "itemOffered.name", "businessFunction", "itemCondition.name", "itemCondition.url", "alternateName", "warranty"]

      const options = {"Banner - XS": bannerFields, "Banner - SM MD LG": bannerFields, "Site Grid": gridFields, "Location Grid": gridFields}

      if (options[businessFunction] === undefined) {
        return true
      }

      return options[businessFunction].includes(fieldKey)
    },
    saveDataOffer: function () {

       this.$validator.validateAll().then((result) => {
        if (result) {
          // check child validations
          let ok = true
          if (this.childValidations) {
            for (let i = 0; i < this.childValidations.length; i++) {
              if (!this.childValidations[i]()) {
                ok = false
              }
            }
          }
          if (!ok) {
            alert('Error saving the new Offer.  Check the form for errors.')
            return
          }
          var newObj = _.clone(this.editOffer, true);
          console.log('saveOffer')
          console.log(newObj)
          let objId = null
          let saving = false
          if (newObj['.key']) {
            objId = newObj['.key']
            delete newObj['.key']
            this.$store.commit('setSavingId', objId)
            this.$firebaseRefs.fbOffer.ref.set(newObj)
          } else {
            if (this.newEntity) {
              if (!isEmpty(this.editOffer["branchCode"])) {
                objId = this.editOffer["branchCode"]
                this.$store.commit('setSavingId', objId)
                this.$firebaseRefs.fbOfferOrg.child(objId).set(newObj)

              } else {
                let newRef = this.$firebaseRefs.fbOfferOrg.push(newObj)
                objId = newRef.key
              }
            } else {
              objId = this.$route.params.entityId
              this.$store.commit('setSavingId', objId)
              this.$firebaseRefs.fbOfferOrg.child(objId).set(newObj)
            }
          }
          newObj.id = objId
          this.$store.commit('appendItems', {firebaseNode: 'Offer', items: [newObj]})
          this.$store.commit('addItemToSearch', {item: newObj, firebaseNode: 'Offer'})
          this.$store.commit('showAlert', true)
          this.closeEdit()
        } else {
          this.$emit('validation-errors', this.errors)
          alert('Error saving the new Offer.  Check the form for errors.')
        }
      })
    },
    checkSaveBatchEditFields: function () {
          var self = this
          this.batchEditFieldsApplied.length = 0

          let editObj = this.editLocalBusiness
              _.each(this.batchEditionFields, fKey => {
                  const val = editObj[fKey]
                  if (self.shouldBatchEdit(val, fKey)) {
                    this.batchEditFieldsApplied.push(fKey)
                  }
              })
          if (this.batchEditFieldsApplied.length > 0) {
            this.confirmModal = !this.confirmModal;
          }
    },
    saveBatchEditFields: function () {
      _.each(this.selectedEntities, entity => {

          var newDays = this.editLocalBusiness.openingHoursSpecification
          var self = this
          if (newDays != null && newDays.length > 0) {
            newDays = newDays.filter(function (value, index, arr) {
              // remove all the day from the newDays from the existing array
              return self.batchEditDays.indexOf(value.dayOfWeek) >= 0
            })
          }


          var existDays = entity.openingHoursSpecification
          if (existDays != null && existDays.length > 0) {
            existDays = existDays.filter(function (value, index, arr) {
              // remove all the day from the newDays from the existing array
              return self.batchEditDays.indexOf(value.dayOfWeek) === -1
            })
          }
          entity.openingHoursSpecification = newDays.concat(existDays)


          let editObj = this.editLocalBusiness
          _.each(this.batchEditionFields, fKey => {
              const val = editObj[fKey]
              if (fKey === 'openingHoursSpecification') {
                self.updateOpeningHoursForBatch(entity)
              } else if (fKey === 'specialOpeningHoursSpecification') {
                self.updateSpecialOpeningHoursForBatch(entity)
              } else {
                entity[fKey] = val
              }
          })
          this.$store.commit('setSavingId', entity.id)
          this.$firebaseRefs.fbLocalBusinessOrg.child(entity.id).set(entity)
          this.$store.commit('appendItems', {firebaseNode: 'LocalBusinesses', items: [entity]})
          this.$store.commit('addItemToSearch', {item: entity, firebaseNode: 'LocalBusinesses'})
      })
      this.confirmModal = !this.confirmModal;
      this.$store.commit('showAlert', true)
      console.log("SAVING BATCH LOCATIONS")
      // console.log(this.selectedEntities)
      this.closeEdit()
    },
    shouldBatchEdit: function (obj, fieldKey) {
      if (fieldKey === 'openingHoursSpecification') {
        return !isEmpty(this.batchEditDays);
      } else if (fieldKey === 'specialOpeningHoursSpecification') {
        return !isEmpty(this.editLocalBusiness.specialOpeningHoursSpecification) || this.shouldClearAllHolidays;
      } else {
        return !isEmpty(obj)
      }
    },
    toggleBatchField: function (event, field) {
      this.batchEditFields[field] = event
      },
      toggleBatchDay: function(shouldUpdate, day) {
      let dayIdx = this.batchEditDays.indexOf(day)
      if (shouldUpdate && dayIdx === -1) {
        this.batchEditDays.push(day)
      } else if (!shouldUpdate && dayIdx >= 0) {
        this.batchEditDays.splice(dayIdx, 1)
      }
    },
    updateOpeningHoursForBatch: function (entity) {
      var newDays = this.editLocalBusiness.openingHoursSpecification
      var self = this
      if (newDays != null && newDays.length > 0) {
        newDays = newDays.filter(function (value, index, arr) {
          // remove all the day from the newDays from the existing array
          return self.batchEditDays.indexOf(value.dayOfWeek) >= 0
        })
      }
      if (newDays != null && newDays.length > 0) {
        this.batchEditFieldsApplied.push('openingHoursSpecification')
      }


      var existDays = entity.openingHoursSpecification
      if (existDays != null && existDays.length > 0) {
        existDays = existDays.filter(function (value, index, arr) {
          // remove all the day from the newDays from the existing array
          return self.batchEditDays.indexOf(value.dayOfWeek) === -1
        })
      }
      entity.openingHoursSpecification = newDays.concat(existDays)
    },
    updateSpecialOpeningHoursForBatch: function (entity) {
     if (this.shouldClearAllHolidays) {
        entity.specialOpeningHoursSpecification = []
        this.batchEditFieldsApplied.push('specialOpeningHoursSpecification')
      } else if (this.editLocalBusiness.specialOpeningHoursSpecification.length > 0) {
        this.batchEditFieldsApplied.push('specialOpeningHoursSpecification')
        entity.specialOpeningHoursSpecification = this.editLocalBusiness.specialOpeningHoursSpecification
      }
    },

    closeEdit: function () {
      this.$router.push({
        name: 'ListOffer'
      })
    },
    initData: function (data) {
      console.log('INIT DATA')
      this.newEntity = false
      _.assign(this.editOffer, data);
      console.log(data)
    },
  },
  computed: {
    batchButtonEnabled: function () {
      var self = this
      this.batchEditFieldsApplied.length = 0

      let editObj = this.editLocalBusiness
          _.each(this.batchEditionFields, fKey => {
              const val = editObj[fKey]
              if (self.shouldBatchEdit(val, fKey)) {
                this.batchEditFieldsApplied.push(fKey)
              }
          })
      return this.batchEditFieldsApplied.length > 0
    },
    offer: function () {
      if (this.$route.params.entityId) {
        return this.fbOffer
      } else {
        return {}
      }
    },
    offerOrg: function () {
      return this.fbOfferOrg
    }
  },
  firebase: function () {
    return {
      fbOffer:  {
        source: db.ref('/Offer/' + this.$route.params.organization + '/' + this.$route.params.entityId),
        asObject: true,
        readyCallback: function (data) {
          console.log('Firebase Offer Loaded')
          if (this.$route.params.entityId) {
            this.initData(this.fbOffer)
          }
        }
      },
      fbOfferOrg:  {
        source: db.ref('/Offer/' + this.$route.params.organization),
        asObject: true,
        readyCallback: function (data) {
          console.log('Firebase OfferOrg Loaded')
          console.log(data)
        }
      }
    }
  }
 }

function isEmpty(obj) {
  if (typeof(obj) == 'undefined' || obj == null) { return true }
  if (typeof(obj) === "string" ) { return obj.length === 0 }
  if (typeof(obj) === "number" ) { return false }
  return Object.keys(obj).length === 0
}

function rndID() {
  return Math.random().toString(36).substr(2).toUpperCase();
}
</script>

<style type="text/css">
.close-modal {
  width: 100%;
  padding: 10px 40px;
}

.close-modal .close {
  font-size: 16px;
}

.edit-location {
  display: block;
  overflow-y: auto;
}

.edit-location-form {}

.edit-location-map-container {
  height: auto;
  width: auto;
  border: 1px solid #FFFFFF;
}

.edit-location-image-upload-row,
.edit-location-address-info,
.edit-location-other-info {
  padding: 1rem;
}

.edit-instructions {
  padding: 20px 40px;
  background-color: #eee;
}

.edit-location-content {
  padding: 40px 0px 40px 0px;
}

.day {
  text-transform: uppercase;
}

.store-hours .dropdown-item a {
  display: block;
}

.store-hours-row {
  margin: 0px;
  padding: 1rem 0px 1rem 0px;
}

.add-hours {
  margin-bottom: 60%;
  margin-left: 5px;
}

.delete-button-margin {
  margin-top: 25px;
}

.store-delete-button-margin {
  margin-top: 18px;
}

.add-button-margin {
  margin-top: 12px;
}

.delete-holiday-button-margin {
  margin-top: 25px;
}

.add-holiday-button-margin {
  margin-top: 12px;
}

.gl-action-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.time-picker input.display-time {
  width: 100%;
  padding: 16px !important;
  font-size: 0.875rem;
  line-height: 1.25;
  color: #333333;
  background-color: #FFF;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  border-radius: 5px !important;
  border: 1px solid #c7c7c7 !important;
  -moz-border-radius: 5px !important;
  -webkit-border-radius: 5px !important;
}

.vdp-datepicker input {
  width: 100%;
  padding: 7px !important;
  font-size: 0.875rem;
  line-height: 1.25;
  color: #333333;
  background-color: #FFF;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  border-radius: 5px !important;
  border: 1px solid #c7c7c7 !important;
  -moz-border-radius: 5px !important;
  -webkit-border-radius: 5px !important;
}

.is-invalid {
  border-color: #f86c6b;
  transition-delay: 0s, 0s;
  transition-duration: 0.15s, 0.15s;
  transition-property: border-color, box-shadow;
  transition-timing-function: ease-in-out, ease-in-out;
}
input.display-time:disabled {
  background-color: #ccc;
}
.v-select .dropdown-toggle {
  border: none;
}
</style>



// WEBPACK FOOTER //
// EditOffer.vue?7c8a8ea5